import gql from 'graphql-tag';

export const REMOVE_TEXT_ASSET_FROM_ARTICLE_GROUP_MUTATION = gql`
  mutation RemoveTextAssetFromArticleGroupMutation(
    $articleGroupId: ID!
    $textAssetId: ID!
    $assetType: AssetTypeEnum!
  ) {
    removeTextAssetFromArticleGroup(articleGroupId: $articleGroupId, textAssetId: $textAssetId, assetType: $assetType) {
      errors
    }
  }
`;
